import MotionHoc from "./MotionHoc";

const HomeComponent = () => {
  return <h1>Home</h1>;
};

const Home = MotionHoc(HomeComponent);

export default Home;
